import Button from '@/components/Button';
import RetailerAdditiveComboBox, {
  RetailerAdditiveComboBoxItem,
} from '@/components/RetailerAdditiveComboBox';

interface ProductListRetailerAssignmentFormProps {
  productListId: string;
  supplierId?: string;
  selectedIds: (string | number)[];
  stagedCount: number;
  onSelect: (item: RetailerAdditiveComboBoxItem) => void;
  onAssign: () => Promise<void> | void;
  submitting?: boolean;
}

const ProductListRetailerAssignmentForm = ({
  productListId,
  supplierId,
  selectedIds,
  stagedCount,
  onSelect,
  onAssign,
  submitting = false,
}: ProductListRetailerAssignmentFormProps) => (
  <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end">
    <div className="w-full sm:max-w-md">
      <RetailerAdditiveComboBox
        productListId={productListId}
        supplierId={supplierId}
        selectedIds={selectedIds}
        onAdd={onSelect}
        disabled={submitting}
      />
    </div>

    <div className="flex items-center gap-3">
      <Button
        onClick={() => void onAssign()}
        loading={submitting}
        disabled={stagedCount === 0}
        variant="primary"
      >
        Assign selected retailers
      </Button>
      {stagedCount > 0 && (
        <span className="text-sm text-gray-600">
          {stagedCount} {stagedCount === 1 ? 'retailer' : 'retailers'} selected
        </span>
      )}
    </div>
  </div>
);

export default ProductListRetailerAssignmentForm;
